import { useTypedContext } from 'hooks/useTypedContext';
import { useMemo } from 'react';
import { DashboardTemplateDataSource } from '../../../../../../../../../../../../../interfaces/dashboards';
import { DashboardDataReducerContext } from '../../../../../../../types';
import { VisualizationDataContext } from '../../../types';

export const useListViewData = () => {
  const visualizationData = useTypedContext(VisualizationDataContext);
  const [dashboardData] = useTypedContext(DashboardDataReducerContext);

  return useMemo(() => {
    if (
      dashboardData.data_source === DashboardTemplateDataSource.DashboardReports
    )
      return visualizationData.reports.current.data;

    if (
      dashboardData.data_source ===
        DashboardTemplateDataSource.AwareSessionData ||
      dashboardData.data_source ===
        DashboardTemplateDataSource.AggregatedAwareSessionData
    )
      return visualizationData.sessions.current.data;

    return visualizationData.items.current.data;
  }, [
    dashboardData.data_source,
    visualizationData.items,
    visualizationData.reports,
    visualizationData.sessions,
  ]);
};
